import { type FeatureModule } from '@store/features/types';

export const patientArtifactsFeature: FeatureModule = {
  id: 'patientArtifacts',
  name: 'Patient Artifacts',
  dependencies: [],
  reducers: {},
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {},
  cleanup: _store => {},
};
